import type { TAPIQueryKeys } from 'common/api-calls/common-api-types.ts';
import { userSpecificApiKey } from 'src/common/utils/apicall/api-key';
import type { Optional } from 'common/types.ts';
import type { APIContactsList } from './types.ts';

const featureApiKey = userSpecificApiKey('contacts');

type Keys = {
  all: never;
  list: Optional<APIContactsList['queries'], 'page'>;
  save: { title?: string };
};
// todo: move to utils
function getKeys<k extends keyof Keys>(key: keyof Keys) {
  return (params?: Keys[k]) => (params ? [featureApiKey, key, ...Object.values(params)] : [featureApiKey, key]);
}

export const apiKeyContacts: TAPIQueryKeys<Keys> = {
  all: () => [featureApiKey],
  list: getKeys('list'),
  save: getKeys('save'),
};
